/**
 * This file is categorized as "Proprietary Framework Code"
 * and is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import {
	Icon,
	IconButton,
	Row,
	Text,
} from 'native-base';
import {
	FontAwesome5,
} from '@expo/vector-icons';
import Picker from '../Picker/Picker';

export default function Pagination(props) {
	const { Repository } = props,
		{
			page,
			pageSize,
			total,
			totalPages,
			pageStart,
			pageEnd,
			pageTotal,
		} = Repository,
		paginationButtonProps = {
			h: '20px',
			w: '20px',
			mx: 1,
		},
		iconProps = {
			position: 'absolute',
			textAlign: 'center',
			color: 'trueGray.400',
		};
		
	let items = [],
		isDisabled = page === 1;
	items.push(<IconButton
					key="first"
					{...paginationButtonProps}
					isDisabled={isDisabled}
					_icon={{
						color: isDisabled ? 'trueGray.400' : 'trueGray.700',
					}}
					icon={<Icon as={FontAwesome5} {...iconProps} name="angle-double-left" />}
					onPress={() => Repository.setPage(1)}
				/>);
	items.push(<IconButton
					key="prev"
					{...paginationButtonProps}
					isDisabled={isDisabled}
					_icon={{
						color: isDisabled ? 'trueGray.400' : 'trueGray.700',
					}}
					icon={<Icon as={FontAwesome5} {...iconProps} name="angle-left" />}
					onPress={() => Repository.prevPage()}
				/>);

	isDisabled = page === totalPages || !totalPages;
	items.push(<IconButton
					key="next"
					{...paginationButtonProps}
					isDisabled={isDisabled}
					_icon={{
						color: isDisabled ? 'trueGray.400' : 'trueGray.700',
					}}
					icon={<Icon as={FontAwesome5} {...iconProps} name="angle-right" />}
					onPress={() => Repository.nextPage()}
				/>);
	items.push(<IconButton
					key="last"
					{...paginationButtonProps}
					isDisabled={isDisabled}
					_icon={{
						color: isDisabled ? 'trueGray.400' : 'trueGray.700',
					}}
					icon={<Icon as={FontAwesome5} {...iconProps} name="angle-double-right" />}
					onPress={() => Repository.setPage(totalPages)}
				/>);

	// Pagesize Picker
	items.push(<Picker
					_select={{
						key: 'pageSize',
						placeholder: 'Page Size',
						selectedValue: pageSize,
						onValueChange: (value) => Repository.setPageSize(value),
						fontSize: 14,
						bg: 'trueGray.200',
						ml: 1,
					}}
					allowNull={false}
					key="pageSize"
					entities={[
						// { id: 1, displayValue: '1/pg'},
						{ id: 5, displayValue: '5/pg'},
						{ id: 10, displayValue: '10/pg'},
						{ id: 20, displayValue: '20/pg'},
						{ id: 50, displayValue: '50/pg'},
						{ id: 100, displayValue: '100/pg'},
					]}
				/>);

	let pageSpan = `${pageStart} – ${pageEnd}`;
	if (pageStart === pageEnd) {
		pageSpan = pageStart;
	}
	
	return <Row
				justifyContent="center"
				alignItems="center"
				w="100%"
				p={2}
				{...props}
			>
				<Text>{pageSpan} of {total}</Text>
				<Row
					justifyContent="center"
					alignItems="center"
					px={3}
				>
					{items}
				</Row>
			</Row>;
};
